import React, { useEffect, useState } from 'react';
import styles from './LoadingScreen.module.scss';

interface LoadingScreenProps {
  active?: boolean;
  onFinished?: () => void;
}

// SVG Path Constants for Antaris Logo & Satellite
const SAT_PATHS = [
  "M31.5925 2.81806L31.2237 2.44926C31.1846 2.41012 31.1315 2.38813 31.0761 2.38813L30.684 2.38813C30.6286 2.38813 30.5756 2.41012 30.5364 2.44926L29.2215 3.7642C29.1823 3.80334 29.1604 3.85642 29.1604 3.91177L29.1604 4.30393C29.1604 4.35928 29.1823 4.41237 29.2215 4.4515L29.5903 4.82031L29.9591 5.18911C29.9982 5.22825 30.0513 5.25024 30.1067 5.25024L30.4988 5.25024C30.5542 5.25024 30.6072 5.22825 30.6464 5.18911L31.9613 3.87417C32.0005 3.83503 32.0225 3.78195 32.0225 3.7266L32.0225 3.33444C32.0225 3.27909 32.0005 3.22601 31.9613 3.18687L31.5925 2.81806Z",
  "M29.5168 4.89612L29.148 4.52732C29.1088 4.48818 29.0558 4.46619 29.0004 4.46619L28.9399 4.46619C28.8846 4.46619 28.8315 4.48818 28.7923 4.52732L28.6812 4.63846C28.6421 4.67759 28.6201 4.73068 28.6201 4.78603L28.6201 4.84653C28.6201 4.90188 28.6421 4.95496 28.6812 4.9941L29.05 5.3629L29.4188 5.7317C29.458 5.77084 29.511 5.79283 29.5664 5.79283H29.6269C29.6822 5.79283 29.7353 5.77084 29.7745 5.7317L29.8856 5.62057C29.9247 5.58143 29.9467 5.52835 29.9467 5.473L29.9467 5.41249C29.9467 5.35714 29.9247 5.30406 29.8856 5.26492L29.5168 4.89612Z",
  "M31.2839 1.21239L31.0828 1.74386C31.0416 1.85248 31.068 1.97511 31.1501 2.05723L32.3543 3.26143C32.4365 3.34355 32.5591 3.36992 32.6677 3.3288L33.1992 3.12763C33.3761 3.06066 33.4249 2.83343 33.2912 2.69967L32.7963 2.20483V1.70207C32.7963 1.6541 32.7575 1.61522 32.7095 1.61522L32.2067 1.61522L31.7119 1.12038C31.5781 0.98662 31.3509 1.03547 31.2839 1.21239Z",
  "M29.9595 2.75818L28.8171 1.6158L28.1793 2.2536C28.0772 2.35571 28.1073 2.52818 28.238 2.58964L29.3908 3.13191C29.4704 3.16932 29.5648 3.15282 29.627 3.09068L29.9595 2.75818Z",
  "M30.0084 2.70927L28.866 1.56689L29.5038 0.929085C29.6059 0.82698 29.7784 0.857097 29.8398 0.987763L30.3821 2.14065C30.4195 2.22018 30.403 2.31463 30.3409 2.37678L30.2602 2.45745L29.8425 1.35192L29.8118 1.38263L30.2264 2.49124L30.0084 2.70927Z",
  "M29.4802 0.486444L29.1731 0.179352C29.0917 0.0979426 28.9597 0.0979424 28.8783 0.179352L28.1781 0.879523L28.78 1.48142L29.2251 1.03636L29.1147 0.741331L29.1455 0.710622L29.2566 1.00484L29.4802 0.781253C29.5616 0.699844 29.5616 0.567854 29.4802 0.486444Z",
  "M28.1292 0.92796L28.7311 1.52986L28.031 2.23003C27.9496 2.31144 27.8176 2.31144 27.7362 2.23003L27.4291 1.92294C27.3477 1.84153 27.3477 1.70954 27.4291 1.62813L28.1292 0.92796Z",
  "M31.6535 4.45117L32.7959 5.59355L32.1581 6.23135C32.056 6.33346 31.8835 6.30334 31.822 6.17267L31.2798 5.01979C31.2424 4.94026 31.2588 4.84581 31.321 4.78366L31.6535 4.45117Z",
  "M31.7028 4.40225L32.8452 5.54464L33.483 4.90684C33.5851 4.80473 33.555 4.63225 33.4243 4.57079L32.2714 4.02853C32.1919 3.99112 32.0974 4.00761 32.0353 4.06976L31.9546 4.15044L33.0601 4.56808L33.0294 4.59879L31.9208 4.18422L31.7028 4.40225Z",
  "M33.9261 4.93117L34.2332 5.23827C34.3146 5.31967 34.3146 5.45167 34.2332 5.53307L33.533 6.23325L32.9311 5.63134L33.3762 5.18628L33.6712 5.29661L33.7019 5.2659L33.4077 5.15476L33.6313 4.93117C33.7127 4.84976 33.8447 4.84976 33.9261 4.93117Z",
  "M33.4837 6.28445L32.8818 5.68255L32.1816 6.38272C32.1002 6.46413 32.1002 6.59612 32.1816 6.67753L32.4887 6.98462C32.5701 7.06603 32.7021 7.06603 32.7835 6.98462L33.4837 6.28445Z"
];

// Scatter direction vectors for each path (x, y, rotation)
const SCATTER_DATA = [
  { x: -35, y: -35, r: -45 },
  { x: -45, y: 15, r: 60 },
  { x: 30, y: -45, r: -30 },
  { x: -60, y: -60, r: 90 },
  { x: -15, y: -75, r: -60 },
  { x: 25, y: -70, r: 45 },
  { x: -55, y: -25, r: -90 },
  { x: 55, y: 55, r: 120 },
  { x: 75, y: 15, r: -45 },
  { x: 15, y: 65, r: 75 },
  { x: 40, y: 40, r: -120 }
];



const LoadingScreen: React.FC<LoadingScreenProps> = ({ active = false, onFinished }) => {
  // stages:
  // 0 -> Satellite entering (0 - 850ms)
  // 1 -> Shockwave glow & scatter (850ms - 1350ms)
  // 2 -> Logo holds & shows loading subtitle (1350ms - waiting for active=false)
  // 3 -> Logo/Satellite fly-away exit (exit duration 650ms)
  const [stage, setStage] = useState(0);

  useEffect(() => {
    // Mount to Stage 1 after entering is done
    const timer1 = setTimeout(() => {
      setStage(1);
    }, 850);

    // Stage 1 to Stage 2 morph hold
    const timer2 = setTimeout(() => {
      setStage(2);
    }, 1350);

    return () => {
      clearTimeout(timer1);
      clearTimeout(timer2);
    };
  }, []);

  // Exit trigger logic when active becomes false
  useEffect(() => {
    if (!active) {
      if (stage === 2) {
        // If we are already holding at stage 2, transition to exit immediately
        setStage(3);
      } else if (stage < 2) {
        // If loading finished extremely fast, wait until morph completes to exit
        const checkInterval = setInterval(() => {
          setStage((curr) => {
            if (curr === 2) {
              clearInterval(checkInterval);
              return 3;
            }
            return curr;
          });
        }, 100);
        return () => clearInterval(checkInterval);
      }
    }
  }, [active, stage]);

  // Complete callback once exit animation completes
  useEffect(() => {
    if (stage === 3) {
      const timer = setTimeout(() => {
        onFinished?.();
      }, 1400);
      return () => clearTimeout(timer);
    }
  }, [stage, onFinished]);

  const scattered = stage >= 1;
  const showLogo = stage >= 1;
  const flashGlow = stage === 1;

  return (
    <div className={`${styles.loadingContainer} ${stage === 3 ? styles.loadingContainerExit : ''}`}>
      {/* Background with glowing orb and grid */}
      <div className={styles.splashBg} aria-hidden>
        <div className={styles.glow} />
        <div className={styles.grid} />
      </div>

      <div className={`${styles.contentArea} ${stage === 3 ? styles.contentAreaExit : ''}`}>
        <div className={styles.visualWrapper}>
          {/* Shockwave Rings */}
          <div className={styles.shockwave}>
            <div className={`${styles.ringOuter} ${flashGlow ? styles.ringOuterActive : ''}`} />
            <div className={`${styles.ringInner} ${flashGlow ? styles.ringInnerActive : ''}`} />
            <div className={`${styles.bloom} ${flashGlow ? styles.bloomActive : ''}`} />
          </div>

          {/* Central Satellite */}
          <div className={`${styles.satelliteContainer} ${styles.satelliteContainerEnter}`}>
            <svg viewBox="0 0 62.6087 18" width="250" height="72" overflow="visible" style={{ display: 'block' }}>
              <g clipPath="url(#splash-sat-clip)">
                {SAT_PATHS.map((d, i) => {
                  const vec = SCATTER_DATA[i] || { x: 0, y: 0, r: 0 };
                  return (
                    <path
                      key={i}
                      d={d}
                      style={{
                        '--tx': `${vec.x * 1.6}px`,
                        '--ty': `${vec.y * 1.6}px`,
                        '--rot': `${vec.r * 1.5}deg`,
                      } as React.CSSProperties}
                      data-scattered={scattered}
                      className={`${styles.satPath} ${scattered ? styles.satPathScatter : ''}`}
                    />
                  );
                })}
              </g>
              <defs>
                <clipPath id="splash-sat-clip">
                  <rect width="62.6087" height="18" fill="white" />
                </clipPath>
              </defs>
            </svg>
          </div>

          {/* Antaris Logo Wings and Text */}
          <div className={`${styles.logoWrapper} ${showLogo ? styles.logoWrapperVisible : ''}`}>
            <svg viewBox="0 0 100 18" width="400" height="72" overflow="visible" style={{ display: 'block' }}>
              <g transform="translate(18.7, 0)">
                {/* Left Wing */}
                <path
                  d="M9.7152 9.14786C14.9326 4.83002 22.6088 3.63062 25.7272 3.57065C25.7272 3.57065 26.087 3.57065 26.087 3.93047C26.087 4.29029 25.7272 4.29029 25.7272 4.29029C22.6088 4.35026 13.4109 6.08939 9.7152 9.14786Z"
                  fill="#F0F0F0"
                  className={`${styles.wingLeft} ${showLogo ? styles.wingLeftVisible : ''}`}
                />

                {/* Right Wing */}
                <path
                  d="M52.3536 9.14786C47.1362 4.83002 39.4601 3.63062 36.3416 3.57065C36.3416 3.57065 35.9818 3.57065 35.9818 3.93047C35.9818 4.29029 36.3416 4.29029 36.3416 4.29029C39.4601 4.35026 48.658 6.08939 52.3536 9.14786Z"
                  fill="#F0F0F0"
                  className={`${styles.wingRight} ${showLogo ? styles.wingRightVisible : ''}`}
                />

                {/* Center Satellite Icon inside Logo */}
                <g className={`${styles.logoIcon} ${showLogo ? styles.logoIconVisible : ''}`}>
                  <path d="M31.5925 2.81806L31.2237 2.44926C31.1846 2.41012 31.1315 2.38813 31.0761 2.38813L30.684 2.38813C30.6286 2.38813 30.5756 2.41012 30.5364 2.44926L29.2215 3.7642C29.1823 3.80334 29.1604 3.85642 29.1604 3.91177L29.1604 4.30393C29.1604 4.35928 29.1823 4.41237 29.2215 4.4515L29.5903 4.82031L29.9591 5.18911C29.9982 5.22825 30.0513 5.25024 30.1067 5.25024L30.4988 5.25024C30.5542 5.25024 30.6072 5.22825 30.6464 5.18911L31.9613 3.87417C32.0005 3.83503 32.0225 3.78195 32.0225 3.7266L32.0225 3.33444C32.0225 3.27909 32.0005 3.22601 31.9613 3.18687L31.5925 2.81806Z" fill="#F0F0F0" />
                  <path d="M29.5168 4.89612L29.148 4.52732C29.1088 4.48818 29.0558 4.46619 29.0004 4.46619L28.9399 4.46619C28.8846 4.46619 28.8315 4.48818 28.7923 4.52732L28.6812 4.63846C28.6421 4.67759 28.6201 4.73068 28.6201 4.78603L28.6201 4.84653C28.6201 4.90188 28.6421 4.95496 28.6812 4.9941L29.05 5.3629L29.4188 5.7317C29.458 5.77084 29.511 5.79283 29.5664 5.79283H29.6269C29.6822 5.79283 29.7353 5.77084 29.7745 5.7317L29.8856 5.62057C29.9247 5.58143 29.9467 5.52835 29.9467 5.473L29.9467 5.41249C29.9467 5.35714 29.9247 5.30406 29.8856 5.26492L29.5168 4.89612Z" fill="#F0F0F0" />
                  <path d="M31.2839 1.21239L31.0828 1.74386C31.0416 1.85248 31.068 1.97511 31.1501 2.05723L32.3543 3.26143C32.4365 3.34355 32.5591 3.36992 32.6677 3.3288L33.1992 3.12763C33.3761 3.06066 33.4249 2.83343 33.2912 2.69967L32.7963 2.20483V1.70207C32.7963 1.6541 32.7575 1.61522 32.7095 1.61522L32.2067 1.61522L31.7119 1.12038C31.5781 0.98662 31.3509 1.03547 31.2839 1.21239Z" fill="#F0F0F0" />
                  <path d="M29.9595 2.75818L28.8171 1.6158L28.1793 2.2536C28.0772 2.35571 28.1073 2.52818 28.238 2.58964L29.3908 3.13191C29.4704 3.16932 29.5648 3.15282 29.627 3.09068L29.9595 2.75818Z" fill="#F0F0F0" />
                  <path d="M30.0084 2.70927L28.866 1.56689L29.5038 0.929085C29.6059 0.82698 29.7784 0.857097 29.8398 0.987763L30.3821 2.14065C30.4195 2.22018 30.403 2.31463 30.3409 2.37678L30.2602 2.45745L29.8425 1.35192L29.8118 1.38263L30.2264 2.49124L30.0084 2.70927Z" fill="#F0F0F0" />
                  <path d="M29.4802 0.486444L29.1731 0.179352C29.0917 0.0979426 28.9597 0.0979424 28.8783 0.179352L28.1781 0.879523L28.78 1.48142L29.2251 1.03636L29.1147 0.741331L29.1455 0.710622L29.2566 1.00484L29.4802 0.781253C29.5616 0.699844 29.5616 0.567854 29.4802 0.486444Z" fill="#F0F0F0" />
                  <path d="M28.1292 0.92796L28.7311 1.52986L28.031 2.23003C27.9496 2.31144 27.8176 2.31144 27.7362 2.23003L27.4291 1.92294C27.3477 1.84153 27.3477 1.70954 27.4291 1.62813L28.1292 0.92796Z" fill="#F0F0F0" />
                  <path d="M31.6535 4.45117L32.7959 5.59355L32.1581 6.23135C32.056 6.33346 31.8835 6.30334 31.822 6.17267L31.2798 5.01979C31.2424 4.94026 31.2588 4.84581 31.321 4.78366L31.6535 4.45117Z" fill="#F0F0F0" />
                  <path d="M31.7028 4.40225L32.8452 5.54464L33.483 4.90684C33.5851 4.80473 33.555 4.63225 33.4243 4.57079L32.2714 4.02853C32.1919 3.99112 32.0974 4.00761 32.0353 4.06976L31.9546 4.15044L33.0601 4.56808L33.0294 4.59879L31.9208 4.18422L31.7028 4.40225Z" fill="#F0F0F0" />
                  <path d="M33.9261 4.93117L34.2332 5.23827C34.3146 5.31967 34.3146 5.45167 34.2332 5.53307L33.533 6.23325L32.9311 5.63134L33.3762 5.18628L33.6712 5.29661L33.7019 5.2659L33.4077 5.15476L33.6313 4.93117C33.7127 4.84976 33.8447 4.84976 33.9261 4.93117Z" fill="#F0F0F0" />
                  <path d="M33.4837 6.28445L32.8818 5.68255L32.1816 6.38272C32.1002 6.46413 32.1002 6.59612 32.1816 6.67753L32.4887 6.98462C32.5701 7.06603 32.7021 7.06603 32.7835 6.98462L33.4837 6.28445Z" fill="#F0F0F0" />
                </g>
              </g>

              {/* Brand text */}
              <text
                x="50.0"
                y="17.0"
                textAnchor="middle"
                fill="#F0F0F0"
                fontSize="6.8"
                fontFamily="var(--font-mono), monospace"
                letterSpacing="0.08em"
                fontWeight="bold"
                className={`${styles.logoText} ${showLogo ? styles.logoTextVisible : ''}`}
              >
                MISSION DESIGN
              </text>
            </svg>
          </div>
        </div>

        {/* Subtitles */}
        <div className={styles.subtitleContainer}>
          <p className={`${styles.subtitleMain} ${showLogo ? styles.subtitleMainVisible : ''}`}>
            Mission Design Platform
          </p>
          <p className={`${styles.subtitleDesc} ${stage >= 2 ? styles.subtitleDescVisible : ''}`}>
            Preparing orbits and assets...
          </p>
        </div>
      </div>
    </div>
  );
};

export default LoadingScreen;
